import React, { useContext, useState } from "react";
import "./MenuItem.scss";
import { AppContext } from "../../App";
import { URL } from "../../constants/url";
import formatNumberWithCommas from "../format/formatNumberWithCommas";
import ConfirmDialog from "../confirmdialog/ConfirmDialog";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { sortById } from "../format/SortByIdTrim";
import EditMenu from "../editmenuform/EditMenu";

const MenuItem = () => {
  const { productData, setProductData } = useContext(AppContext);
  const [editItem, setEditItem] = useState("");
  const [addingNewItem, setAddingNewItem] = useState(false);
  const [formData, setFormData] = useState({
    idTrimItem: "",
    name: "",
    price: "",
    image: "",
  });
  const [showConfirm, setShowConfirm] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  // function get value when click --------------------------------------------

  const handleEditClick = (item) => {
    setEditItem(item._id);
    setAddingNewItem(false);
    setFormData({
      idTrimItem: item.idTrimItem,
      name: item.name,
      price: item.price,
      image: item.image,
    });
  };

  // function on Change value input ----------------------------------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // function upload image -----------------------------------------------------

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onloadend = () => {
      setFormData((prevData) => ({
        ...prevData,
        image: reader.result,
      }));
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };

  // function post item and update item ----------------------------------------------

  const handleSubmit = (e) => {
    setIsLoading(true);
    e.preventDefault();
    if (editItem) {
      fetch(`${URL}/api/products/${editItem}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Success:", data);
          setEditItem(null);

          const updatedProducts = productData.map((product) =>
            product._id === editItem ? { ...product, ...formData } : product
          );
          setProductData(updatedProducts);
          setFormData({
            idTrimItem: "",
            name: "",
            price: "",
            image: "",
          });
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("Error:", error);
          setErrorMessage("size image too large");
        });
    } else {
      fetch(`${URL}/api/products`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Success:", data);
          setFormData({
            idTrimItem: "",
            name: "",
            price: "",
            image: "",
          });
          setAddingNewItem(false);
          setProductData([...productData, data]);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error("Error:", error);
          setErrorMessage("size image too large");
          setIsLoading(false);
        });
    }
  };

  // function delete item---------------------------------------------

  const handleDelete = () => {
    if (itemToDelete !== null) {
      const id = itemToDelete;
      console.log(id);
      const apiUrl = `${URL}/api/products/${id}`;

      fetch(apiUrl, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.ok) {
            // Find the index of the item to delete
            const updatedProductData = [...sortedProductData];
            const index = updatedProductData.findIndex(
              (item) => item._id === id
            );

            if (index !== -1) {
              updatedProductData.splice(index, 1);
              setProductData(updatedProductData);
            } else {
              console.error("Item not found in the product data.");
            }

            setShowConfirm(false);
            setItemToDelete(null);
          } else {
            console.error("Error deleting item:", response.status);
          }
        })
        .catch((error) => {
          console.error("Error deleting item:", error);
        });
    }
  };

  // function cancel delete and confirm delete item----------------------------------------------

  const handleCancel = () => {
    setShowConfirm(false);
    setItemToDelete(null);
  };

  const confirmDelete = (item) => {
    setItemToDelete(item._id);
    setShowConfirm(true);
  };

  // function close Popup-------------------------------------------------
  const closePopup = () => {
    setEditItem(null);
    setAddingNewItem(false);
    setFormData({
      idTrimItem: "",
      name: "",
      price: "",
      image: "",
    });
    setErrorMessage("");
    setIsLoading(false);
  };

  // sort data------------------------------------------------------
  const sortedProductData = sortById(productData);

  setTimeout(() => {
    setErrorMessage("");
  }, 9000);

  return (
    <div className="list-item-menu">
      <div className="frame-table-menu">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Price</th>
              <th>Image</th>
              <th>Edit</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {sortedProductData.map((item, index) => (
              <tr key={index}>
                <td>{item.idTrimItem}</td>
                <td>{item.name}</td>
                <td>{formatNumberWithCommas(item.price)}</td>
                <td>
                  <img src={item.image} alt={item.name} />
                </td>
                <td>
                  <button
                    onClick={() => handleEditClick(item)}
                    className="button-edit-menu"
                  >
                    <EditIcon className="icon-menu-edit" />
                  </button>
                </td>
                <td>
                  <button
                    type="button"
                    onClick={() => confirmDelete(item)}
                    className="button-remove-menu"
                  >
                    <DeleteIcon className="icon-menu-remove" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {(editItem || addingNewItem) && (
        <EditMenu
          formData={formData}
          handleChange={handleChange}
          handleImageChange={handleImageChange}
          handleSubmit={handleSubmit}
          errorMessage={errorMessage}
          isLoading={isLoading}
          closePopup={closePopup}
        />
      )}

      {!editItem && !addingNewItem && (
        <button
          onClick={() => setAddingNewItem(true)}
          className="button-add-item"
        >
          Add New Item
        </button>
      )}

      {showConfirm && (
        <ConfirmDialog
          message="Are you sure you want to delete this item?"
          onConfirm={handleDelete}
          onCancel={handleCancel}
        />
      )}
    </div>
  );
};

export default MenuItem;
